import React from 'react'
import { Parallax } from 'react-parallax'
import { CFImage, CFView, DefaultScreen, MobileScreen } from 'components'
import { about, promo2, mobileAbout } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView>
          <CFImage src={mobileAbout} w="100%" alt="About" />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView w="100%" column center>
          <CFImage src={about} w="100%" alt="Promotions" />
          <CFImage src={promo2} w="100%" alt="Promo 2" />
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
